import { render, staticRenderFns } from "./editMyData.vue?vue&type=template&id=824e5010&scoped=true&"
import script from "./editMyData.vue?vue&type=script&lang=js&"
export * from "./editMyData.vue?vue&type=script&lang=js&"
import style0 from "./editMyData.vue?vue&type=style&index=0&id=824e5010&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824e5010",
  null
  
)

export default component.exports